import { FC } from 'react'
import CalculationPosition from '../../../../../../types/api/calculation-position'
import { Popover, Space, theme } from 'antd'
import getDistance from '../../../../../../helpers/fields-calculation/stamps/get-distance'
import getNumberOfLabelsInFlood from '../../../../../../helpers/fields-calculation/stamps/get-number-of-labels-in-flood'
import calcStampCost from '../../../../../../helpers/calculations/calc-stamp-cost'
import outputCalculatedValue from '../../../../../../helpers/formatters/output-calculated-value'
import CaretUpOutlined from '@ant-design/icons/lib/icons/CaretUpOutlined'
import Stamp from '../../../../../../types/api/stamp'

interface StampNumberProps {
    data: {
        stamp?: Stamp
    }
}

const StampNumber: FC<StampNumberProps> = ({ data }) => {
    const { token } = theme.useToken()
    const stamp = data.stamp
    if (!stamp) return null

    const labelsInFlood = getNumberOfLabelsInFlood({
        roller: stamp.roller?.roller,
        range: stamp.range,
        length: stamp.length,
    })
    const stampCost =
        !stamp.last_order && labelsInFlood
            ? calcStampCost({
                  shape: stamp.shape,
                  floods: stamp.floods,
                  width: stamp.width,
                  length: stamp.length,
                  labelsInFlood,
              })
            : null

    return (
        <Popover
            title={<>Штамп № {stamp.number}</>}
            content={
                <Space direction={'vertical'}>
                    {/* TODO: тут не хватает инфы, то надо делать запрос за штампом при наведении */}

                    {!stamp.last_order ? (
                        <span>
                            Новый <CaretUpOutlined style={{ color: token.blue5 }} />
                        </span>
                    ) : null}
                    <span>Форма: {stamp.shape}</span>
                    {stamp.tube?.number != null && <span>№ тубуса: {stamp.tube.number}</span>}
                    {stampCost != null && stampCost > 0 && (
                        <span>Стоимость: {outputCalculatedValue(stampCost)} руб.</span>
                    )}
                    <span>Ширина: {stamp.width}</span>
                    <span>Длина: {stamp.length}</span>
                    <span>Ручьи: {stamp.floods}</span>
                    <span>Межэтикетка: {getDistance(stamp).toFixed(3)}</span>
                    {stamp.comment != null && <span>Комментарий: {stamp.comment}</span>}
                    {stamp.radius != null && <span>Радиус: {stamp.radius}</span>}
                    {stamp.contractor?.name != null && (
                        <span>Производитель: {stamp.contractor?.name}</span>
                    )}

                    <span></span>
                </Space>
            }
            placement={'rightBottom'}
        >
            {stamp.number}
            {!stamp.last_order ? (
                <>
                    {' '}
                    <CaretUpOutlined style={{ color: token.blue5 }} />
                </>
            ) : null}
        </Popover>
    )
}

export default StampNumber
